import { Button, Stack, TextField, Typography, Box, Select, FormControl, InputLabel, MenuItem } from '@mui/material';
import { FormProvider } from 'react-hook-form';
import Radio from 'common/Radio';
import { VisibleEnum } from 'types';
import { ErrorMessageVia } from '@app/components/ErrorMessage/style';

import { StyledFormHelperText, StyledBox } from './styled';
import { useMutationCertificatesLogic } from './utility/useMutationCertificatesLogic';
import FilesWrapper from './FilesWrapper';

const MutationCertificates = () => {
  const {
    pdf,
    certificateId,
    methods,
    category,
    errors,
    isSuccess,
    pdfFile,
    otherFile,
    previews,
    categories,
    isImageViewOpen,
    isButtonLoading,
    imageSrcForAction,
    isDeleteModalOpen,
    largeImageMessage,
    updateCertificateImagesFromBackend,
    watch,
    setValue,
    setState,
    onSubmit,
    register,
    handleSubmit,
    onChangeUpload,
  } = useMutationCertificatesLogic();

  return (
    <FormProvider {...methods}>
      <Stack
        onSubmit={handleSubmit(onSubmit)}
        component="form"
        sx={{
          gap: '10px',
          '.MuiFormHelperText-root': {
            margin: '0px'
          }
        }}
      >
        <Typography variant="h5">
          {certificateId ? `Update Certificate` : `Create New Certificate`}
        </Typography>
        <StyledBox>
          <TextField
            {...register('titleAm')}
            value={watch('titleAm')}
            label="Title Am"
            error={!!errors.titleAm?.message}
            helperText={errors.titleAm?.message}
          />
          <TextField
            {...register('titleEn')}
            value={watch('titleEn')}
            label="Title En"
            error={!!errors.titleEn}
            helperText={errors.titleEn?.message}
          />
          <TextField
            {...register('titleRu')}
            value={watch('titleRu')}
            label="Title Ru"
            error={!!errors.titleRu}
            helperText={errors.titleRu?.message}
          />
        </StyledBox>
        <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Category</InputLabel>
          <Select
            error={!!errors.category?.message}
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            label="category"
            multiple
            value={category}
            onChange={(e) => {
              const selectedList = e.target.value as string[]

              setValue('category', selectedList)
            }}
          >
            {categories?.map((cat) => {
              return <MenuItem value={cat.id} key={cat.id}>{cat.titleEn}</MenuItem>
            })}
          </Select>
          {errors.category?.message && <ErrorMessageVia>{errors.category?.message}</ErrorMessageVia>}
        </FormControl>
        <FilesWrapper
          pdf={pdf}
          errors={errors}
          pdfFile={pdfFile}
          previews={previews}
          setState={setState}
          otherFile={otherFile}
          imageSrcForAction={imageSrcForAction}
          isImageViewOpen={isImageViewOpen}
          onChangeUpload={onChangeUpload}
          isDeleteModalOpen={isDeleteModalOpen}
        />
        <div>
          <Box>
            Visible in website
          </Box>
          <Radio label="Yes" name="visible" canBe={VisibleEnum.YES} />
          <Radio label="No" name="visible" canBe={VisibleEnum.NO} />
        </div>
        {largeImageMessage && <StyledFormHelperText id="messages">{largeImageMessage}</StyledFormHelperText>}
        <p>{isSuccess}</p>
        <Button
          type="submit"
          color="primary"
          variant="contained"
          disabled={isButtonLoading}
        >
          Submit
        </Button>
      </Stack>
    </FormProvider>
  );
};

export default MutationCertificates;
